import Box from "@mui/material/Box";
import { useDispatch, useSelector } from "react-redux";
import Button from "@mui/material/Button";

import Paper from "@mui/material/Paper";
import HomeIcon from "@mui/icons-material/Home";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";

import { actionMapMapviewChangeRequested } from "../Map";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {
  actionMapviewCurrentIndexUpdated,
  actionMapviewIgnoreUpdated,
} from "../App";
import Tooltip from "@mui/material/Tooltip";
import { actionMapResetMapCenter } from "../Map/MapRedux";

import { trackEvent } from "../../tracking";
import { MGIS_DOC_LINK } from "../Shared/util";

const root_ = (theme) => ({
  display: "flex",
  flexDirection: "column",
  marginBottom: "1px",
  "& .MuiButton-root": {
    color: "black",
  },
});

const widget_ = (theme) => ({
  // 44x44 min size is needed to meet this accessibility requirement:
  // https://www.w3.org/WAI/WCAG22/Understanding/target-size-enhanced.html
  width: 44,
  height: 44,
  minWidth: "unset",
  backgroundColor: "#ffffff",
  border: "1px solid #f0f0f0",
  [theme.breakpoints.down("sm")]: {
    width: 34,
    "& .MuiSvgIcon-root": {
      fontSize: "1.25rem",
    },
  },
});

const btns_ = (theme) => ({
  display: "flex",
  flexDirection: "column",
  backgroundColor: "transparent",
  boxShadow: "none",
  "&:hover": {
    "& button": {
      borderRadius: "0px",
    },
  },
});

// Compact back/forward control.
// The overall control remains 44x44, while each button is half width.
const historyBtns_ = (theme) => ({
  width: 44,
  height: 44,
  display: "flex",
  backgroundColor: "transparent",
  boxShadow: "none",

  "& .MuiButton-root": {
    width: 24,
    minWidth: 24,
    height: 44,
    padding: 0,
    borderRadius: 0,
    border: "1px solid #f0f0f0",

    "&:not(:disabled)": {
      backgroundColor: "#ffffff",
    },
  },
});
export default function Zoom() {
  const dispatch = useDispatch();

  const mapViewHistory = useSelector(
    (state) => state.miscReducer.mapViewHistory,
  );

  const mapViewCurrentIndex = useSelector(
    (state) => state.miscReducer.mapViewCurrentIndex,
  );

  const clickHandler = (value) => () => {
    const targetIndex = mapViewCurrentIndex + value;
    const targetMapView = mapViewHistory[targetIndex];
    const { lng, lat, zoom, pitch, bearing } = targetMapView;

    dispatch(actionMapviewIgnoreUpdated(+1));

    dispatch(
      actionMapMapviewChangeRequested({
        center: [lng, lat],
        zoom,
        pitch,
        bearing,
      }),
    );

    dispatch(actionMapviewCurrentIndexUpdated(targetIndex));
  };

  const helpHandler = () => {
    trackEvent({
      category: "Map Widget",
      action: "Help",
    });

    window.open(MGIS_DOC_LINK, "_blank", "noopener,noreferrer");
  };

  const resetHandler = () => {
    dispatch(actionMapResetMapCenter());

    trackEvent({
      category: "Map Widget",
      action: "Reset Map View",
    });
  };

  return (
    <>
      <Box sx={root_}>
        <Paper sx={btns_}>
          <Tooltip title="MGIS Documentation">
            <Button onClick={helpHandler} variant="contained" sx={widget_}>
              <QuestionMarkIcon />
            </Button>
          </Tooltip>

          <Tooltip title="Reset Map View">
            <Button onClick={resetHandler} variant="contained" sx={widget_}>
              <HomeIcon />
            </Button>
          </Tooltip>

          <Paper sx={historyBtns_}>
            <Tooltip
              describeChild
              title={`Previous Map View${
                mapViewCurrentIndex === 0 ? " (Disabled)" : ""
              }`}
            >
              <span>
                <Button
                  onClick={clickHandler(-1)}
                  variant="contained"
                  disabled={mapViewCurrentIndex === 0}
                  aria-label="Previous Map View"
                >
                  <ArrowBackIcon />
                </Button>
              </span>
            </Tooltip>

            <Tooltip
              describeChild
              title={`Next Map View${
                mapViewCurrentIndex >= mapViewHistory.length - 1
                  ? " (Disabled)"
                  : ""
              }`}
            >
              <span>
                <Button
                  onClick={clickHandler(1)}
                  variant="contained"
                  disabled={mapViewCurrentIndex >= mapViewHistory.length - 1}
                  aria-label="Next Map View"
                >
                  <ArrowForwardIcon />
                </Button>
              </span>
            </Tooltip>
          </Paper>
        </Paper>
      </Box>
    </>
  );
}
